export type UserState = 'NEW' | 'IN_PROGRESS' | 'COMPLETED';

export type Interviewer = {
  key: string;
  nameKey: string;
  tagKey: string;
  /** 난이도 ★ 개수 */
  difficulty: 1 | 2 | 3;
  quoteKey: string;
  /** 3D 카드 배경 (스테이지용, 짙은 톤) */
  cardBg: string;
  /** 어드민 CDN 전신 캐릭터 (RGBA 투명 PNG) */
  imageSrc: string;
  special?: boolean;
};

const CDN_BASE = process.env.NEXT_PUBLIC_CDN_URL;

export const cdnImage = (file: string) => `${CDN_BASE}/public/static-images/${file}`;

/** cardBg 그라데이션 하단(캡션·페이드) 색 */
export const getCardBottomColor = (cardBg: string): string => {
  const matches = cardBg.match(/#[0-9A-Fa-f]{6}/g);
  return matches?.at(-1) ?? '#FFFFFF';
};

/** 인물 하단 → 카드 배경색으로 이어지는 페이드 */
export const getCardImageFadeGradient = (cardBg: string): string => {
  const bottom = getCardBottomColor(cardBg);
  const [r, g, b] = [
    Number.parseInt(bottom.slice(1, 3), 16),
    Number.parseInt(bottom.slice(3, 5), 16),
    Number.parseInt(bottom.slice(5, 7), 16),
  ];
  return `linear-gradient(to bottom, transparent 0%, rgba(${r},${g},${b},0.45) 55%, ${bottom} 100%)`;
};

/** 면접관 key → CDN 이미지 (FeatureStack 등 공유) */
export const getInterviewerImageSrc = (key: string) =>
  INTERVIEWERS.find((person) => person.key === key)?.imageSrc ?? '';

/** 스테이지 전체 면접관 목록 */
export const INTERVIEWERS: Interviewer[] = [
  {
    key: 'dora',
    nameKey: 'ai_interviews.hero.interviewer.dora.name',
    tagKey: 'ai_interviews.hero.interviewer.dora.tag',
    difficulty: 1,
    quoteKey: 'ai_interviews.hero.interviewer.dora.quote',
    cardBg: 'linear-gradient(180deg,#FFF0BF,#F3DFA6)',
    imageSrc: cdnImage('04f768a2-9a83-4157-8faf-f8dff675fca4.png'),
  },
  {
    key: 'taeri',
    nameKey: 'ai_interviews.hero.interviewer.taeri.name',
    tagKey: 'ai_interviews.hero.interviewer.taeri.tag',
    difficulty: 2,
    quoteKey: 'ai_interviews.hero.interviewer.taeri.quote',
    cardBg: 'linear-gradient(180deg,#CFEAE5,#AFD8D1)',
    imageSrc: cdnImage('a437fd9b-52d4-41d3-8524-ea8694e70a31.png'),
  },
  {
    key: 'hyeongseok',
    nameKey: 'ai_interviews.hero.interviewer.hyeongseok.name',
    tagKey: 'ai_interviews.hero.interviewer.hyeongseok.tag',
    difficulty: 3,
    quoteKey: 'ai_interviews.hero.interviewer.hyeongseok.quote',
    cardBg: 'linear-gradient(180deg,#CFE0F2,#AFC7E4)',
    imageSrc: cdnImage('758387eb-6a9c-4ea7-b315-11e3a8048cf3.png'),
  },
  {
    key: 'hyangro',
    nameKey: 'ai_interviews.hero.interviewer.hyangro.name',
    tagKey: 'ai_interviews.hero.interviewer.hyangro.tag',
    difficulty: 3,
    quoteKey: 'ai_interviews.hero.interviewer.hyangro.quote',
    cardBg: 'linear-gradient(180deg,#F8D2DC,#EBB4C3)',
    imageSrc: cdnImage('0764f2c6-ab03-44dc-b29b-216974b992ae.png'),
    special: true,
  },
  {
    key: 'seonggyeom',
    nameKey: 'ai_interviews.hero.interviewer.seonggyeom.name',
    tagKey: 'ai_interviews.hero.interviewer.seonggyeom.tag',
    difficulty: 2,
    quoteKey: 'ai_interviews.hero.interviewer.seonggyeom.quote',
    cardBg: 'linear-gradient(180deg,#D6EFCF,#B7DEAE)',
    imageSrc: cdnImage('63e5bf5d-c3b3-4aa8-8707-7ffd93d85049.png'),
  },
  {
    key: 'hyejeong',
    nameKey: 'ai_interviews.hero.interviewer.hyejeong.name',
    tagKey: 'ai_interviews.hero.interviewer.hyejeong.tag',
    difficulty: 3,
    quoteKey: 'ai_interviews.hero.interviewer.hyejeong.quote',
    cardBg: 'linear-gradient(180deg,#DFD6F2,#C3B5E2)',
    imageSrc: cdnImage('dad38a37-71cd-4bda-91d7-471a2c1c4d66.png'),
  },
];

/** 히어로 캐러셀 기본 정면 — 향로 */
export const DEFAULT_HERO_FRONT_INDEX = INTERVIEWERS.findIndex(
  (person) => person.key === 'hyangro',
);
